import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../../context/AuthContext";
import { IndosbookLogo } from "../IndosbookLogo";
import PasswordInput from "../PasswordInput";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { adminLogin, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user?.role === "admin") navigate("/admin/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await adminLogin(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail, "Login failed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <IndosbookLogo size={28} />
        <div className="mt-6 flex items-center gap-2">
          <ShieldCheck className="h-5 w-5 text-[#002855]" />
          <h1 className="text-xl font-extrabold text-slate-900" style={{ fontFamily: '"Poppins", sans-serif' }}>Admin Console</h1>
        </div>
        <p className="mt-1 text-sm text-slate-500">Restricted area. Authorised staff only.</p>

        <div className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="admin-email">Email</Label>
            <Input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-11" data-testid="admin-email-input" autoComplete="username" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="admin-password">Password</Label>
            <PasswordInput id="admin-password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input" placeholder="Admin password" />
          </div>
        </div>

        {error && <p className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm font-semibold text-red-600" data-testid="admin-login-error">{error}</p>}

        <Button type="submit" disabled={submitting} data-testid="admin-login-submit"
          className="mt-6 h-11 w-full rounded-full bg-[#002855] font-bold text-white hover:bg-[#001d40]">
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
